import { createSlice } from "@reduxjs/toolkit";

const crowdsaleSlice = createSlice({
    name: 'crowdsale',
    initialState: {
        address: '',
        contract: {},
        tokenPrice: 0,
        tokenPriceBucks: 0,
        tokenBnbPrice: 0,
        tokensSold: 0,
        tokenMyFrozen: 0
    },
    reducers: {
        setCrowdsaleInfo(state, { payload: { address, contract, tokenPrice, tokenPriceBucks, tokenBnbPrice, tokensSold, tokenMyFrozen } }) {
            state.address = address;
            state.contract = contract;
            state.tokenPrice = tokenPrice;
            state.tokenPriceBucks = tokenPriceBucks;
            state.tokenBnbPrice = tokenBnbPrice;
            state.tokensSold = tokensSold;
            state.tokenMyFrozen = tokenMyFrozen;
        }
    }
})
export const {
    setCrowdsaleInfo
  } = crowdsaleSlice.actions
export default crowdsaleSlice.reducer;